import React from 'react';
import Layout from './Layout';
import store from './lib/store';
import { Provider } from 'react-redux';
import './index.css';
import ReactDOM from 'react-dom/client';
import './styles/styles.scss';
import { MantineProvider, createTheme } from '@mantine/core';

const theme = createTheme({
  breakpoints: {
    sm: '0em',
    md: '46.5em',
    lg: '80em',
    xl: '90em',
  },
});

ReactDOM.createRoot(document.getElementById('react-app')).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Provider store={store}>
        <Layout />
      </Provider>
    </MantineProvider>
  </React.StrictMode>
);
